import { Link } from "react-router-dom";
import { useAppStore } from "../lib/store/useAppStore";
import { useRef, useState } from "react";
import { useClickOutSide } from "lib/hooks/useClickOutside";
import { useTranslation } from "react-i18next";
import LocaleSwitcher from "./LocaleSwitcher";

function AsideCollapseIcon({ isCollapsed }) {
  return (
    <svg
      className="asideCollapseToggle__icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect x="4" y="4" width="16" height="16" rx="2.4" />
      <path d="M9.5 4.4V19.6" />
      {isCollapsed ? (
        <path d="M13.6 9L16.6 12L13.6 15" />
      ) : (
        <path d="M16.6 9L13.6 12L16.6 15" />
      )}
    </svg>
  );
}

export default function Header({
  isAsideCollapsed = false,
  onAsideCollapsedChange,
  showAsideToggle = true,
}) {
  const userName = useAppStore((s) => s.user?.user_name);
  const logout = useAppStore((s) => s.logout);
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClickToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalRef = useRef();

  useClickOutSide([modalRef], () => {
    setIsModalOpen(false);
  });

  const collapseToggleLabel = isAsideCollapsed
    ? t("aside.expandNavigation", { defaultValue: "Expand sidebar" })
    : t("aside.collapseNavigation", { defaultValue: "Collapse sidebar" });

  return (
    <header className={showAsideToggle ? undefined : "header--withoutAsideToggle"}>
      {showAsideToggle ? (
        <button
          type="button"
          className="asideCollapseToggle"
          onClick={() => onAsideCollapsedChange?.((current) => !current)}
          aria-label={collapseToggleLabel}
          aria-expanded={!isAsideCollapsed}
          aria-controls="appAsideNavigation"
          title={collapseToggleLabel}
        >
          <AsideCollapseIcon isCollapsed={isAsideCollapsed} />
        </button>
      ) : null}
      <h1>
        <Link to="/project">
          <img src="/images/mainLogo.png" alt="" />
        </Link>
      </h1>
      <div>
        <LocaleSwitcher />
        <div>
          <Link onClick={onClickToggle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 40 40"
              fill="none"
            >
              <circle
                cx="20"
                cy="13"
                r="7"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <path
                d="M10 33
     C10 27 14 23 20 23
     C26 23 30 27 30 33"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <path
                d="M12 33 H28"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            {userName ? <span>{userName}</span> : null}
            <span>{t("header.userLabel")}</span>
          </Link>

          {isModalOpen && (
            <ul ref={modalRef}>
              <li>
                <Link
                  onClick={() => {
                    if (isModalOpen) setIsModalOpen(false);
                  }}
                  to={"/user"}
                >
                  {t("header.userProfileLink")}
                </Link>
              </li>
            </ul>
          )}
        </div>
        <button onClick={logout} title={t("header.logoutButtonTitle")}>
          {t("header.logoutButtonLabel")}
        </button>
      </div>
    </header>
  );
}
